export default __webpack_public_path__ + "static/media/main-background.654d626c.jpeg";